module.exports = __webpack_public_path__ + "html/week2_4369c87474f907beb97b1160e6b38a1d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week2.html
// module id = DHQn
// module chunks = 151